import {
	SWITCH_COURSE_REQUEST,
	SWITCH_COURSE,
	SWITCH_COURSE_SUCCESS,
	SWITCH_COURSE_FAILED
} from '../constants';
import { put, take, call, select } from 'redux-saga/effects';
import apiClient from '../lib/celled_client';
import { checkCommonErrors } from '../lib/auth';
import { learnerFlowInfo } from './learner_flow_info'
import { toggleSwitchModal } from '../actions/chat'
import { toggleCourseConfirmationModal } from '../actions/course_details'
import { getUserId } from './selectors';

export function* switchCourse() {
	while (true) {
		yield take(SWITCH_COURSE_REQUEST)
		try {
			const flowInfo = yield call(learnerFlowInfo)
			if (flowInfo.canSwitch) {
				yield put(toggleCourseConfirmationModal())
			} else {
				yield put(toggleSwitchModal())
			}
		} catch (error) {
			var errorMessage = error.response.data.message;
			let errorPayload = {
				type: SWITCH_COURSE_FAILED,
				notification: {
					message: errorMessage,
					className: 'error',
					type: 'switchCourse',
					unique: true,
				},
			};
			yield put(checkCommonErrors(error, errorPayload));
		}
	}
}

export function* switchCourseFetch() {
	while (true) {
		const data = yield take(SWITCH_COURSE)
		const userId = yield select(getUserId);
		try {
			yield call(apiClient.switchCourse, userId, data.courseCode, data.startAt)
			yield put({
				type: SWITCH_COURSE_SUCCESS,
				notification: {
					message: 'You have successfully switched your course',
					type: 'switchCourse',
					unique: true,
				},
			})
		} catch (error) {
			var errorMessage = error.response.data.message;
			let errorPayload = {
				type: SWITCH_COURSE_FAILED,
				notification: {
					message: errorMessage,
					className: 'error',
					type: 'switchCourse',
					unique: true,
				},
			};
			yield put(checkCommonErrors(error, errorPayload));
		}
	}
}

export default function* rootSwitchCourseSaga() {
	yield [
		switchCourse(),
		switchCourseFetch()
	];
};
